import { useEffect } from 'react';
import { menuTitle } from '../utils/menu-cn';

const useSetTitle = () => {
  useEffect(() => {
    const pathName = window.location.pathname || '/';
    const title = menuTitle[pathName] || menuTitle['/'];
    if (document.title !== title) {
      document.title = title;
    }
  }, []);
};

export default useSetTitle;